<template>
  <div class="mx-2 pb-1" :class="screenType !== 'desktop' && uploadStep === 2 && 'remaining-space-hidden d-flex flex-column'">
    <StepForMobile
      :currentStep="2"
      :screenType="screenType"
      :title="this.$t('Select Files')"
    />
    <div
      :class="[screenType !== 'desktop' && 'single-step-wrapper-mobile remaining-space d-flex flex-column']"
      v-if="screenType === 'desktop' || uploadStep === 2"
    >
      <FileDirButtons
      :lightSessionRestart="lightSessionRestart"
      :session="session"
      :screenType="screenType"
      />

      <FilesTableForMobile
        v-if="
          screenType !== 'desktop' &&
          uploadStep === 2 &&
          session.filesData.length
        "
        :session="session"
      />
    </div>
    <StartRestartButtons
    v-if="screenType !== 'desktop' && uploadStep === 2"
    :session="session"
    :filteringErrMessage="filteringErrMessage"
    :setIsShowFilteringErrMessage="v => (isShowFilteringErrMessage = v)"
    :startFilteringClicked="startFilteringClicked"
    :restartSessionClicked="restartSessionClicked"
    :setIsShowUploadingDetails="v => (isShowUploadingDetails = v)"
    :buttonText="$t('Continue')"
    :screenType="screenType"
    />
  </div>
</template>

<script>
import StepForMobile from '@/components/WebsiteInterface/CommonComponents/StepForMobile.vue'
import FileDirButtons from '@/components/WebsiteInterface/CommonComponents/FileDirButtons/FileDirButtons.vue'
import FilesTableForMobile from '@/components/WebsiteInterface/CommonComponents/Mobile/FilesTableForMobile.vue'
import StartRestartButtons from '@/components/WebsiteInterface/WebsiteInterfaceDesktop/Childern/UploadDesktop/Children/UploadingDetails/Children/StartRestartButtons/StartRestartButtons.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'SelectFiles',
  setup() {
    //
  },
  props: {
    session: Object,
    filteringErrMessage: String,
    startFilteringClicked: Function,
    restartSessionClicked: Function,
    lightSessionRestart: Function,
    screenType: String,
    setIsShowFilteringErrMessage: Function,
    setIsShowUploadingDetails: Function,
  },
  computed: {
    ...mapGetters(['uploadStep']),
  },
  components: {
    StepForMobile,
    FileDirButtons,
    FilesTableForMobile,
    StartRestartButtons,
  },
}
</script>
